import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "27",
  height: "24",
  fill: "none",
  viewBox: "0 0 27 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#a3c90e",
      d: "M13.495 0c.432 0 .825.244 1.013.633l3.215 6.623 7.182 1.06c.421.06.773.356.904.764a1.13 1.13 0 0 1-.276 1.148l-5.208 5.166 1.228 7.294c.07.421-.103.848-.45 1.101a1.12 1.12 0 0 1-1.186.08l-6.422-3.431-6.417 3.426c-.38.202-.839.174-1.186-.08a1.14 1.14 0 0 1-.455-1.101l1.229-7.294-5.208-5.16a1.12 1.12 0 0 1-.277-1.15c.131-.402.483-.698.905-.763l7.181-1.06L12.483.633c.192-.39.581-.633 1.012-.633"
    }, null, -1)
  ]))]))
}
export default { render: render }